import { connect } from 'react-redux';
import React, { useRef, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import MaterialIcon from 'material-icons-react';

import {
  Bold,
  Link,
  Header,
  HelpText,
  SubHeader,
  Background,
  LoginPanel,
  LoginHeader,
  MarginRight,
  LoginContent,
  LoginContain,
  MarginBotton,
  SearchLightLogo,
  LoginCard as Card,
  LoginButtonContain
} from './Styled';

import Button from 'components/Button';
import TextInput from 'components/TextInput';
import ErrorDisplay from 'components/ErrorDisplay';

import { login, resetPassword } from 'actions/session';
import { errorClear, errorSet } from 'actions/error';

import validator from './validation';

const ResetContainer = ({
  errors,
  history,
  loading,
  lastReset,
  errorMessage,
  dispatchError,
  dispatchErrorClear,
  dispatchResetPassword
}) => {
  const lastResetRef = useRef(lastReset);
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(
    function clearErrors() {
      dispatchErrorClear();
    },
    [dispatchErrorClear]
  );

  useEffect(
    function onResetSuccess() {
      if (lastResetRef.current !== lastReset) {
        setSuccess(true);
      }

      lastResetRef.current = lastReset;
    },
    [lastReset]
  );

  const handleReset = () => {
    let [isValid, inputErrors] = validator(email);

    if (!isValid) {
      return dispatchError({ inputErrors });
    }

    dispatchResetPassword(email);
  };

  const onEmailChange = (n, value) => {
    if (errors.email) {
      dispatchError({ inputErrors: {} });
    }

    setEmail(value);
  };

  const onLogin = () => history.replace('/login');

  const renderReset = () => (
    <React.Fragment>
      <HelpText>
        <MarginRight>
          <MaterialIcon
            size={'small'}
            icon="info_outline"
            color={'rgb(1, 118, 190)'}
          />
        </MarginRight>
        <span>
          Enter your email address below. If you have a registered account we'll send
          you a link to reset your password.
        </span>
      </HelpText>

      <TextInput
        bold
        fullWidth
        name={'email'}
        value={email}
        disabled={loading}
        errorText={errors.email}
        label={'Email Address'}
        onChange={onEmailChange}
        placeholder={'Enter your email address'}
      />

      <LoginButtonContain>
        <Button.Primary
          label={'Reset Password'}
          icon={!loading && 'mail_outline'}
          loading={loading}
          disabled={loading}
          onClick={handleReset}
        />
      </LoginButtonContain>

      <MarginBotton />
    </React.Fragment>
  );

  const renderSuccess = () => (
    <React.Fragment>
      <SubHeader>Please check your email.</SubHeader>
      <HelpText>
        <MarginRight>
          <MaterialIcon
            size={'small'}
            icon="mail_outline"
            color={'rgb(1, 118, 190)'}
          />
        </MarginRight>
        <span>
          Please check your email <Bold>{email}</Bold> and follow the instructions to
          reset your password.
        </span>
      </HelpText>
    </React.Fragment>
  );

  return (
    <Background>
      <LoginContain>
        <LoginPanel>
          <Card>
            <LoginHeader>
              <SearchLightLogo />
              <Header>Reset Password</Header>
            </LoginHeader>

            <LoginContent>
              {success ? renderSuccess() : renderReset()}

              {!loading && <ErrorDisplay message={errorMessage} />}

              <Link href="#" onClick={onLogin}>
                Back to Login
              </Link>
            </LoginContent>
          </Card>
        </LoginPanel>
      </LoginContain>
    </Background>
  );
};

const mapDispatchToProps = {
  dispatchLogin: login,
  dispatchError: errorSet,
  dispatchErrorClear: errorClear,
  dispatchResetPassword: resetPassword
};

const mapStateToProps = ({ error, session, loading }) => ({
  isAuth: session.isAuth,
  errorMessage: error.message,
  errors: error.inputErrors || {},
  loading: loading.loadingResetPassword,
  lastReset: session.lastPasswordReset
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ResetContainer)
);
